'use client';
import { useCalendarPickerStyles_unstable } from '../CalendarPicker/useCalendarPickerStyles.styles';
/**
 * Apply styling to the CalendarMonth slots based on the state
 *
 * @internal
 */ export const useCalendarMonthStyles_unstable = (props)=>{
    'use no memo';
    return useCalendarPickerStyles_unstable(props);
};
